const generateDiceBearAvatar = (gender, name) => `
  https://api.dicebear.com/9.x/adventurer/svg`;

export default generateDiceBearAvatar;
